<template>
  <div class="MCommentList font-body-s">
    <div v-for="comment in getComments()" :key="comment._id">
      <m-item-comment
          :comment="comment"
          :unique-item-name="uniqueItemName"
      />
    </div>
    <div
        v-if="limitComments < itemComments.length && itemComments.length > 0"
        class="show-more has-text-centered mt-4"
        @click="setLimitComments">
      <chevron-down-icon size="14"/>
      <b>{{ $t('dict.showMoreComments') }}</b>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.show-more {
  cursor: pointer;
  transition: opacity .2s;

  &:hover {
    opacity: .9;
  }
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import MItemComment from '@/components/molecules/comment/MItemComment.vue';
import { ItemDetailStore } from '@/store';
import { ChevronDownIcon } from 'vue-feather-icons';

@Component({
  components: { MItemComment, ChevronDownIcon }
})
export default class MCommentList extends Vue {
  limitComments = 3;

  get itemComments () {
    return ItemDetailStore.getItemComments;
  }

  get uniqueItemName () {
    return ItemDetailStore.getItemUniqueItemName;
  }

  getComments () {
    const comments = JSON.parse(JSON.stringify(this.itemComments));
    comments.reverse();
    return comments.splice(0, this.limitComments);
  }

  setLimitComments () {
    this.limitComments = this.itemComments.length;
  }
}
</script>